const localizers = {
  'loading.msg': () => `Laden...`,
  'logon.message.msg': () => `Authenticatie is verplicht. Voer een geldige gebruikers-ID en een geldig wachtwoord in.`,
  'logon.button.msg': () => `Aanmelden...`,
  'SASServer.logonError.msg': () => `Aanmelding bij de server is mislukt.`,
  'SASServer.genericError.msg': () => `De server is niet bereikbaar.`,
}
export default localizers;
